import { MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import * as moment from 'moment';

const {
  ISO_8601,
  HTML5_FMT: { DATETIME_LOCAL, DATE }
} = moment;

export const MAT_MOMENT_DATE_FORMATS: MatDateFormats = {
  parse: { dateInput: [ISO_8601, DATETIME_LOCAL, DATE, 'L'] },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

export const MAT_MOMENT_DATE_PROVIDER_CONFIG = [
  { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
  { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
];
